"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { useState } from "react";
import { PersonData } from "@/types/person";
import AvatarImage from '../../../../public/defaultavatar.webp';
interface Props {
  profile: PersonData;
}
export default function CrewHero(t0) {
  const $ = _c(44);
  const {
    profile
  } = t0;
  const [isExpanded, setIsExpanded] = useState(false);
  let t1;
  if ($[0] !== profile.media) {
    t1 = profile.media?.find(_temp)?.media_url || AvatarImage;
    $[0] = profile.media;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const avatar = t1;
  profile.media?.find(_temp2)?.media_url || "/images/backdrop-placeholder.jpg";
  const getTruncatedText = _temp3;
  const biography = profile.biography || "";
  let t2;
  if ($[2] !== biography) {
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = /\s+/;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    t2 = biography.split(t3);
    $[2] = biography;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const wordCount = t2.length;
  let t3;
  if ($[5] !== biography) {
    t3 = getTruncatedText(biography, 200);
    $[5] = biography;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const truncatedBio = t3;
  const shouldShowButton = wordCount > 200;
  const t4 = profile.name_fa || "bac";
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      objectPosition: "50% 35%"
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== avatar || $[9] !== t4) {
    t6 = <Image src={avatar} alt={t4} fill={true} priority={true} className="object-cover blur-sm scale-125" style={t5} />;
    $[8] = avatar;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="absolute inset-0 bg-linear-to-b from-black/40 via-black/70 to-[#0d0d1b]" />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6) {
    t8 = <div className="absolute inset-0">{t6}{t7}</div>;
    $[12] = t6;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = profile.name_fa || "avatar";
  let t10;
  if ($[14] !== avatar || $[15] !== t9) {
    t10 = <div className="shrink-0"><div className="relative w-20 h-20 md:w-28 md:h-28 rounded-full overflow-hidden ring-4 ring-white/10 bg-white/5"><Image src={avatar} alt={t9} fill={true} priority={true} fetchPriority="high" decoding="async" quality={85} className="object-top object-cover" /></div></div>;
    $[14] = avatar;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== profile.name_fa) {
    t11 = <h1 className="text-xl md:text-3xl font-extrabold text-white">{profile.name_fa}</h1>;
    $[17] = profile.name_fa;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== profile.name_en) {
    t12 = profile.name_en && <div className="text-sm md:text-base text-white/70">{profile.name_en}</div>;
    $[19] = profile.name_en;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== biography || $[22] !== isExpanded || $[23] !== shouldShowButton || $[24] !== truncatedBio) {
    t13 = biography && <div className="mt-4 hidden lg:block"><p className="text-sm md:text-base leading-7 text-white/80 max-w-4xl">{isExpanded ? biography : truncatedBio}</p>{shouldShowButton && <button onClick={() => setIsExpanded(!isExpanded)} className="mt-2 text-sm md:text-base text-blue-400 hover:text-blue-300 transition-colors font-medium">{isExpanded ? "\u0646\u0645\u0627\u06CC\u0634 \u06A9\u0645\u062A\u0631" : "\u0646\u0645\u0627\u06CC\u0634 \u0628\u06CC\u0634\u062A\u0631"}</button>}</div>;
    $[21] = biography;
    $[22] = isExpanded;
    $[23] = shouldShowButton;
    $[24] = truncatedBio;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t11 || $[27] !== t12 || $[28] !== t13) {
    t14 = <div className="min-w-0 flex-1">{t11}{t12}{t13}</div>;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t10 || $[31] !== t14) {
    t15 = <div className="flex items-start justify-between gap-6 pt-20">{t10}{t14}</div>;
    $[30] = t10;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== biography || $[34] !== isExpanded || $[35] !== shouldShowButton || $[36] !== truncatedBio) {
    t16 = biography && <div className="mt-4 block lg:hidden"><p className="text-sm md:text-base leading-7 text-white/80 max-w-4xl">{isExpanded ? biography : truncatedBio}</p>{shouldShowButton && <button onClick={() => setIsExpanded(!isExpanded)} className="mt-2 text-sm md:text-base text-blue-400 hover:text-blue-300 transition-colors font-medium">{isExpanded ? "\u0646\u0645\u0627\u06CC\u0634 \u06A9\u0645\u062A\u0631" : "\u0646\u0645\u0627\u06CC\u0634 \u0628\u06CC\u0634\u062A\u0631"}</button>}</div>;
    $[33] = biography;
    $[34] = isExpanded;
    $[35] = shouldShowButton;
    $[36] = truncatedBio;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t15 || $[39] !== t16) {
    t17 = <div className="relative z-10 px-6 md:px-10 py-8 md:py-10 ">{t15}{t16}</div>;
    $[38] = t15;
    $[39] = t16;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t17 || $[42] !== t8) {
    t18 = <section className="relative w-full min-h-[360px] md:min-h-[400px] overflow-hidden rounded-2xl ">{t8}{t17}</section>;
    $[41] = t17;
    $[42] = t8;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  return t18;
}
function _temp3(text, wordLimit) {
  const words = text.split(/\s+/);
  if (words.length <= wordLimit) {
    return text;
  }
  return words.slice(0, wordLimit).join(" ") + "...";
}
function _temp2(m_0) {
  return m_0.media_type === "backdrop";
}
function _temp(m) {
  return m.media_type === "person_media" || m.media_type === "person_profile";
}